import React from 'react'

import HSGCard from '../../../../Components/HSGCard/HSGCard'

const DATE_OPTIONS = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: "Asia/Kolkata"};

class EpisodeCard extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            selectedTab: 0
        }
    }

    componentWillMount() {}

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    getValueInputDivision = (className, label, input, defaultInput) => (
        input || defaultInput ?
        <div className={className}>
            <label className = "hsg-sv-label">{label}</label>
            <label className = "hsg-sv-input">{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    _renderStudentBasicInfo = (student) => {

        let studentClass = student.class ? (student.class + (student.section ? ' | ' + student.section : '')) : 'NA'

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className = "hsg-sv-label">{'Basic Info'}</label>
                    <label className = "hsg-sv-label right" style = {{color: '#a0c2ff', cursor: "pointer"}} onClick = {() => this.props.openStudentProfile(student.student_id)}>{'View Profile'}</label>
                </div>         
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">     
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Class: ', studentClass, 'NA')}
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'HSG Id: ', student.uuid, 'NA')}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Gender: ', student.gender, 'NA')}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'DOB: ', student.dob, 'NA')}
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Admission Number: ', student.admission_number, 'NA')}
                </div>
            </div>
        )
    }

    _renderStudentParentInfo = (parent) => {

        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : 'NA'

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className = "hsg-sv-label">{'Parent Info'}</label>
                </div>         
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">  
    
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Name: ', parentName, 'NA')}
                    {this.getValueInputDivision("row col-md-4 col-sm-12 col-xs-12", 'Email: ', parent.user_email, 'NA')}
                    {this.getValueInputDivision("row col-md-4 col-sm-12 col-xs-12", 'Contact: ', parent.user_phone_number, 'NA')}

                </div>
            </div>
        )
    }

    formatEpisodeStrings = (string) => (
        // string ? string.trim().slice(0,-1).toUpperCase() : null
        string ? string.trim().toUpperCase() : null
    )

    _renderStudentEpisodeInfo = (episode, props) => {

        let contactInfo = episode.med_called_ambulance ? `Connected with Ambulance` : null
        contactInfo = episode.med_called_parents ? contactInfo ? contactInfo + ' and Parent': 'Connected with Parent' : null
        contactInfo = contactInfo ? contactInfo + ' During this Episode.': null

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                {   
                    !!props.enableEpisodeIdLabelBody &&
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className = "hsg-sv-label">{'Episode Info'}</label>
                    </div>     
                }    
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">    
                    {!!props.enableEpisodeIdInBody && this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Episode Id: ', episode.med_episode_id, null)}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Complaints: ', this.formatEpisodeStrings(episode.med_complaint), null)}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Symptoms: ', this.formatEpisodeStrings(episode.med_symptoms), null)}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Suggestions: ', this.formatEpisodeStrings(episode.med_suggestion), null)}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Remarks: ', episode.med_remarks && episode.med_remarks.toUpperCase() || null, null)}
                    {this.getValueInputDivision("row col-md-12 col-sm-12 col-xs-12", 'Info: ', contactInfo, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Height: ', episode.med_height, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Weight: ', episode.med_weight, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Dia: ', episode.med_bp_dia, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Sys: ', episode.med_bp_sys, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Resp: ', episode.med_respiratory_rate, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Body Temp: ', episode.med_body_temp, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-6 col-xs-6", 'Heart Rate: ', episode.med_heart_rate, null)}
                </div>
            </div>
        )
    }

    getHeading = (headingType, episode) => (
        headingType === 'Name' 
            ? episode.name 
            : headingType === 'EpisodeId' 
                ? episode.episode_custom_json && episode.episode_custom_json.med_episode_id 
                : headingType === 'ModifiedTime' 
                    ? episode.episode_custom_json && episode.episode_custom_json.med_created 
                        ? (new Date(episode.episode_custom_json.med_created)).toLocaleDateString('en-US', DATE_OPTIONS)
                        : '' : ''
    )

    render(){

        let props = this.props
        let { episode, index } = props
        
        let headingLeft = episode && this.getHeading(props.headingLeft, episode)
        let heagingRight = episode && this.getHeading(props.headingRight, episode)

        return (
            <HSGCard 
                headingLeft = {`${headingLeft || 'NA'}`} 
                headingRight = {`${heagingRight || 'NA'}`} 
                key = {index}
            > 

                <div style ={{marginBottom: 10}}></div>
                {props.basicInfo && <div className="hsg-card-details row"> {this._renderStudentBasicInfo(episode, props)} </div>}

                {props.parentInfo && <div className="hsg-card-details row"> {this._renderStudentParentInfo(episode, props)} </div>}

                {props.episodeInfo && <div className="hsg-card-details row"> {this._renderStudentEpisodeInfo(episode.episode_custom_json, props)} </div>}

            </HSGCard>
        )
    }
}

export default EpisodeCard


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/Episode/EpisodeCard.js